// EmailJS credentials — set these as environment variables in Cloudflare Pages dashboard
// See CONTACT_SETUP.md in the project root for instructions
export const EMAILJS = {
  serviceId:           process.env.REACT_APP_EMAILJS_SERVICE_ID        || '',
  contactTemplate:     process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE  || '',
  newsletterTemplate:  process.env.REACT_APP_EMAILJS_NEWSLETTER_TEMPLATE || '',
  publicKey:           process.env.REACT_APP_EMAILJS_PUBLIC_KEY        || '',
};

export const isEmailJSReady = () =>
  Boolean(EMAILJS.serviceId && EMAILJS.publicKey && EMAILJS.contactTemplate);
